<app-select-procesos
    [enableFilterConcept]="enableFilterConcept"
    [tipoConcepto]="'procesos'"
    (filtersList)="chargeFiltersInTable($event)"
>
</app-select-procesos>
